import ParaGamesForm from "../../components/ParaGamesForm";

export default function ParaSports2025() {
  return (
    <>
    {
      <div style={{margin: 2, padding: 20}}>
        <h2>
          पंजीकरण की तिथि समाप्त हो गई है/ Registrations are closed
        </h2>
      </div>
    }
    {/* {<ParaGamesForm />} */}
    </>
  );
}
